var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{staticClass:"mt-0",attrs:{"label":_vm.label,"color":"green darken-2"},on:{"click":_vm.handleSaveByDefault},model:{value:(_vm.saveByDefault),callback:function ($$v) {_vm.saveByDefault=$$v},expression:"saveByDefault"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11f68e9a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myHabiteoStudio/steps/components/StepSaveByDefaultCheckbox.vue
// module id = null
// module chunks = 